import { compose } from "lodash/fp";

export const formatSymbol = compose(removeMarketSuffix);

/**
 * 移除 symbol 的市場後綴（如 .US、.TW、.HK 等）
 * @param symbol 股票代碼（可能包含市場後綴）
 * @returns 去除市場後綴的 symbol
 */
export function removeMarketSuffix(symbol: string): string {
  return symbol.replace(/\.[A-Z]+$/, "");
}
